module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 677
// module chunks = 0